export { default } from "./useMediaQuery.mjs";
export * from "./useMediaQuery.mjs";